export default {
  root: {
    padding: '10px 18px',
    paddingBottom: 0
  }
};
